/** WHICH EDGES OF A ROOM THE HAND CAN DRAG (sheet row 141).
 *
 *  A room is the space its walls leave, so a room edit never moves a wall:
 *  walls move as walls, and the rooms follow them (Tudor, 04.11.2026,
 *  reversing the 17.09 request). An edge with a wall along all or part of it
 *  therefore has no handle. Two kinds keep theirs: an edge with no wall (a
 *  threshold or an open line, where only the line moves) and every edge of a
 *  balcony, whose walls are its parapets, carried with the slab.
 *
 *  Kept out of `model.ts` on purpose: that module's exports are the editor
 *  assistant's levers, and the assistant's own room-edge lever
 *  (`mutaLaturaCamerei`) is unchanged. */
import type { TronsonDoc } from "../doc";
import { laturileCamerei, type LaturaCamerei } from "./model";

/** An edge this short gets no handle: it could not be grabbed apart from the
 *  corners beside it. Filtered here, once, so the panel's note and the canvas
 *  agree on a room with no handle. */
const LATURA_MINIMA = 0.25;

export function laturileDeTras(doc: TronsonDoc, i: number): LaturaCamerei[] {
  const balcon = doc.plan?.rooms?.[i]?.kind === "balcony";
  return laturileCamerei(doc, i)
    .filter((l) => !l.tintuita && (!l.ziduri.length || balcon)
      && l.sus - l.jos > LATURA_MINIMA);
}
